export const Features = [
  {
    id: 15,
    title: "Software Customization",
    freePlandescription: "Starting from Rs. 5000",
    standardPlandescription: "Starting from Rs. 5000",
    proPlandescription: "Starting from Rs. 5000",
  },
  
  {
    id: 13,
    title: "Stock Management",
    freePlandescription: "✔",
    proPlandescription: "✔",
    standardPlandescription: "✔",
  },
  {
    id: 0,
    title: "Sales and Invoices",
    freePlandescription: "✔",
    standardPlandescription: "✔",
    proPlandescription: "✔",
  },
  {
    id: 1,
    title: "Purchases",
    freePlandescription: "✔",
    standardPlandescription: "✔",
    proPlandescription: "✔",
  },
  {
    id: 2,
    title: "Payments",
    freePlandescription: "✔",
    standardPlandescription: "✔",
    proPlandescription: "✔",
  },
  {
    id: 3,
    title: "Ledgers",
    freePlandescription: "✔",
    standardPlandescription: "✔",
    proPlandescription: "✔",
  },
  {
    id: 4,
    title: "Banks",
    freePlandescription: "✔",
    standardPlandescription: "✔",
    proPlandescription: "✔",
  },
  {
    id: 5,
    title: "Reports",
    freePlandescription: "✔",
    standardPlandescription: "✔",
    proPlandescription: "✔",
  },
  {
    id: 6,
    title: "Employee Salary",
    freePlandescription: "✔",
    standardPlandescription: "✔",
    proPlandescription: "✔",
  },
  {
    id: 7,
    title: "Employee Access",
    freePlandescription: "✔",
    standardPlandescription: "✔",
    proPlandescription: "✔",
  },
  {
    id: 8,
    title: "Order Booking",
    freePlandescription: "✔",
    standardPlandescription: "✔",
    proPlandescription: "✔",
  },
  {
    id: 9,
    title: "Daily Book",
    freePlandescription: "✔",
    standardPlandescription: "✔",
    proPlandescription: "✔",
  },


  {
    id: 10,
    title: "Cash in Hand",
    freePlandescription: "✔",
    proPlandescription: "✔",
    standardPlandescription: "✔",
  },

  {
    id: 11,
    title: "Warehouse",
    freePlandescription: "✔",
    proPlandescription: "✔",
    standardPlandescription: "✔",
  },
  {
    id: 12,
    title: "Online Store",
    freePlandescription: "✔",
    proPlandescription: "✔",
    standardPlandescription: "✔",
  },

  {
    id: 14,
    title: "Mobile Usage",
    freePlandescription: "✔",
    proPlandescription: "✔",
    standardPlandescription: "✔",
  },

  
];
